import PodcastPoster from "@components/Blocks/Card/Thumbnail/PodcastPoster";
import { ThumbnailProps } from "@components/Blocks/Card/Thumbnail/ThumbnailCard";
import VideoPoster from "@components/Blocks/Card/Thumbnail/VideoPoster";
import React from "react";

export type ThumbnailCardStyles = {
  outerWrapperStyle?: string;
  buttonStyle?: string;
  wrapperStyle?: string;
};

type PosterProps = {
  src: string;
  formattedTime?: string;
  posterDimensions?: {
    style?: string;
    width: number;
    height: number;
  };
};
type TimeElementProps = { publishTime: string };

export const variantConfig: Record<
  ThumbnailProps<unknown>["variant"],
  {
    Wrapper: "div" | "button";
    Poster: React.FC<PosterProps>;
    showPremium: boolean;
    showDescription: boolean;
    styles: ThumbnailCardStyles;
    TimeElement?: React.FC<TimeElementProps>;
    showName?: boolean;
  }
> = {
  video: {
    Wrapper: "div",
    Poster: (props: PosterProps) => React.createElement(VideoPoster, props),
    showPremium: false,
    showDescription: true,
    styles: {
      wrapperStyle: "gap-2",
    },
  },
  webinar: {
    Wrapper: "div",
    Poster: (props: PosterProps) => React.createElement(VideoPoster, props),
    TimeElement: (props: TimeElementProps) =>
      React.createElement(
        "span",
        { className: "font-light" },
        ` - ${props.publishTime}`,
      ),
    showPremium: true,
    showDescription: true,
    styles: {
      wrapperStyle: "self-start",
    },
  },
  podcast: {
    Wrapper: "button",
    Poster: (props: PosterProps) => React.createElement(PodcastPoster, props),
    showPremium: false,
    showDescription: false,
    styles: {},
  },
  kaki_makan_page: {
    Wrapper: "div",
    Poster: (props: PosterProps) => React.createElement(VideoPoster, props),
    showPremium: false,
    showDescription: false,
    showName: false,
    styles: {
      outerWrapperStyle: "max-w-[334px] py-0 lg:py-0 gap-2.5 flex-col",
      wrapperStyle: "gap-2",
    },
  },
  landscape_video_page: {
    Wrapper: "div",
    Poster: (props: PosterProps) => React.createElement(VideoPoster, props),
    showPremium: false,
    showDescription: false,
    styles: {
      outerWrapperStyle: "gap-2.5 py-0 lg:py-0",
      buttonStyle: "w-[172px] h-[97px]",
      wrapperStyle: "gap-2.5",
    },
  },
  short_form_video_block: {
    Wrapper: "div",
    Poster: (props: PosterProps) => React.createElement(VideoPoster, props),
    showPremium: false,
    showDescription: false,
    showName: false,
    styles: {
      outerWrapperStyle: "max-w-[334px] py-0 lg:py-0 gap-0 flex-col",
      buttonStyle: "max-w-[300px]",
      wrapperStyle: "gap-0",
    },
  },
};
